import countryList from "react-select-country-list";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import { useParams } from "react-router";

import ContactPhoneIcon from "@material-ui/icons/ContactPhone";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import AddAlert from "@material-ui/icons/AddAlert";
import MenuItem from "@material-ui/core/MenuItem";
import Person from "@material-ui/icons/Person";
import "react-phone-input-2/lib/style.css";
import Box from "@material-ui/core/Box";

import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import CardHeader from "components/Card/CardHeader.js";
import GridItem from "components/Grid/GridItem.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Loader from "components/Loader/Loader.js";
import Card from "components/Card/Card.js";

import formStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import { fetchGetRequest } from "common/service";
import { API_BASE_URL } from "common/constants";
import { fetchRequest } from "common/service";

const styles = () => ({
  labelFocused: {
    color: "#E73F3B !important",
  },
  inputFocused: {
    "&:before": {
      borderBottom: "2px solid #E73F3B !important",
    },
    "&:after": {
      borderBottom: "2px solid #E73F3B !important",
    },
    "& input": {
      borderBottom: "#E73F3B !important",
    },
  },
  inputRoot: {
    color: "red",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});

const InputBox = withStyles(styles)((props) => {
  const { labelText, helperText, classes, value, id, info, updateInfo, type, required, nestedKey } = props;
  return (
    <TextField
        InputLabelProps={{shrink: true, classes: {focused: classes.labelFocused}}}
        InputProps={{classes: {root: classes.root, focused: classes.inputFocused}}}
        required={required ? required : false}
        type={type ? type : "text"}
        helperText={helperText}
        label={labelText}
        color="primary"
        margin="normal"
        value={value}
        fullWidth
        onChange={(e) => {
            if (nestedKey) {
              updateInfo({
                ...info,
                [nestedKey]: {
                  ...(info?.[nestedKey] || {}),
                  [id]: e.target.value,
                },
              });
            } else {
              let obj = {};
              obj[id] = e.target.value;
              updateInfo({ ...info, ...obj });
            }
        }}
    />
  );
});

const SelectBox = withStyles(styles)((props) => {
  const {
    disabled,
    labelText,
    classes,
    value,
    id,
    info,
    updateInfo,
    options,
    required,
    customField,
  } = props;
  return (
    <TextField
      select
      fullWidth
      disabled={disabled || false}
      label={labelText}
      value={value}
      required={required ? required : false}
      margin="normal"
      color="primary"
      onChange={(e) => {
        if (id === "role") {
          const guestAccountDetail = customField.find(
            (val) => val.name === "Guest Account"
          );
          let obj = {};
          obj[id] = e.target.value;
          obj[guestAccountDetail.fieldId] =
            e.target.value === "Guest" ? "Yes" : "No";
          updateInfo({ ...info, ...obj });
        } else {
          let obj = {};
          obj[id] = e.target.value;
          updateInfo({ ...info, ...obj });
        }
      }}
      InputLabelProps={{
        shrink: true,
        classes: {
          focused: classes.labelFocused,
        },
      }}
      InputProps={{
        classes: {
          root: classes.root,
          focused: classes.inputFocused,
        },
      }}
    >
      {options}
    </TextField>
  );
});

const useStyles = makeStyles(formStyle);

export default function CreateFacility() {
  const history = useHistory();
  const classes = useStyles();
  const { id } = useParams();

  const [refreshData, setRefreshData] = useState(Date.now());
  const [toastStatus, setToastStatus] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [companyList, setCompanyList] = useState({});
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({
    contactInfo: {}
  });

  useEffect(() => {
    setLoading(true);
    getCompanyList();
    setTimeout(() => {
        id && getFacilityDetailsById(id);
    }, 200);
  }, []);

  const getCompanyList = async() => {
    const endPoint = `${API_BASE_URL}/user/supplier`;
    const list = await fetchGetRequest("GET", endPoint);
    setCompanyList(list?.content || []);
    setLoading(false);
  }

  const getFacilityDetailsById = async() => {
    const endPoint = `${API_BASE_URL}/user/practice/${id}`;
    const facilityDetails = await fetchGetRequest("GET", endPoint);
    setUserInfo(facilityDetails);
    setRefreshData(Date.now());
    setLoading(false);
  }

  let validateForm = async() => {
    setToastStatus(false);
    if (
      !userInfo?.name ||
      !userInfo?.supplierId ||
      !userInfo?.emailAddress ||
      !userInfo?.contactInfo?.streetAddress1 ||
      !userInfo?.contactInfo?.city ||
      !userInfo?.contactInfo?.state ||
      !userInfo?.contactInfo?.country ||
      !userInfo?.contactInfo?.zipcode ||
      !userInfo?.contactInfo?.primaryPhone
    ) {
      setAlertMessage("Fields mark with asterisk are required");
      setToastStatus(true);
    } else {
      setLoading(true);
      const emailReg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!emailReg.test(userInfo?.emailAddress)) {
        setAlertMessage("Please enter valid email");
        setToastStatus(true);
      } else {
        const companyObject = {
          customData: null,
          practice: {
            name: userInfo.name,
            emailAddress: userInfo.emailAddress,
            supplierId: userInfo.supplierId,
            contactInfo: userInfo.contactInfo,
            tenantId: "ATS-DEV",
          },
        };
        console.log(companyObject, 'companyObject');
        const endPoint = `${API_BASE_URL}/user/practice-custom`;
        let requestResponse = null;
        
        if (!id) {
            requestResponse = await fetchRequest("POST", endPoint, companyObject, true);
        } else {
            companyObject.practice.active = userInfo.status === "Active" ? true : false;
            companyObject.practice.status = userInfo.status;
            companyObject.practice.practiceId = id;
            requestResponse = await fetchRequest("PUT", endPoint, companyObject, true);
        }

        setLoading(false);
        if ([200, 201].includes(requestResponse?.response?.status)) {
          setAlertMessage("Facility updated successfully");
          setToastStatus(true);
          setTimeout(() => {
              history.push(`/admin/facility`);
          }, 1000);
        } else {
          setAlertMessage("Failed to update facility");
          setToastStatus(true);
        }
      }
    }
  };

  return (
    <GridContainer key={refreshData}>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="danger" icon>
            <CardIcon color="danger">
              <Person />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>General Information</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  updateInfo={setUserInfo}
                  value={userInfo.name}
                  labelText="Facility Name"
                  info={userInfo}
                  required={true}
                  id="name"
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  value={userInfo.emailAddress}
                  updateInfo={setUserInfo}
                  labelText="Facility Email"
                  id="emailAddress"
                  required={true}
                  info={userInfo}
                  type="email"
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <Box paddingTop={2}>
                  <Autocomplete
                    getOptionLabel={(option) =>option.name}
                    options={companyList}
                    className={classes.inputColor}
                    disableCloseOnSelect
                    fullWidth
                    color="primary"
                    value={userInfo?.supplierId ? companyList?.find((data) => data.supplierId === userInfo?.supplierId) : null}
                    onChange={(event, val) => {
                      if (val) {
                        setUserInfo({ ...userInfo, supplierId: val.supplierId });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        label="Select Company"
                        required={true}
                        {...params}
                        InputLabelProps={{ shrink: true, classes: { focused: classes.labelFocused }}}
                        SelectProps={{classes: {focused: classes.labelFocused}}}
                      />
                    )}
                  />
                </Box>
              </GridItem>
              {id && (
                <GridItem xs={12} sm={12} md={4}>
                  <SelectBox
                    id="status"
                    labelText="Status"
                    required={true}
                    value={userInfo?.status}
                    info={userInfo}
                    updateInfo={setUserInfo}
                    options={["Active", "Inactive"].map((val) => (
                      <MenuItem classes={{root: classes.selectMenuItem}} key={val} value={val}>{val}</MenuItem>
                    ))}
                  />
                </GridItem>
              )}
            </GridContainer>
          </CardBody>
        </Card>
        <Card>
          <CardHeader color="danger" icon>
            <CardIcon color="danger">
              <ContactPhoneIcon />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Facility Contact Information</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  required={true}
                  labelText="Street Address 1"
                  id="streetAddress1"
                  value={userInfo?.contactInfo?.streetAddress1}
                  info={userInfo}
                  updateInfo={setUserInfo}
                  nestedKey="contactInfo"
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  labelText="Street Address 2"
                  id="streetAddress2"
                  value={userInfo?.contactInfo?.streetAddress2}
                  info={userInfo}
                  updateInfo={setUserInfo}
                  nestedKey="contactInfo"
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  required={true}
                  labelText="City"
                  id="city"
                  value={userInfo?.contactInfo?.city}
                  info={userInfo}
                  updateInfo={setUserInfo}
                  nestedKey="contactInfo"
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  required={true}
                  labelText="State"
                  id="state"
                  value={userInfo?.contactInfo?.state}
                  info={userInfo}
                  updateInfo={setUserInfo}
                  nestedKey="contactInfo"
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <Box paddingTop={2}>
                  <Autocomplete
                    getOptionLabel={(option) => option.label ? option.label : option}
                    options={countryList().getData()}
                    className={classes.inputColor}
                    disableCloseOnSelect
                    color="primary"
                    fullWidth
                    value={userInfo?.contactInfo?.country ? countryList().getData().find((data) => data.value === userInfo?.contactInfo?.country): null}
                    onChange={(event, val) => {
                      if (val) {
                        setUserInfo({ ...userInfo, contactInfo: { ...userInfo.contactInfo, country: val.value } });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Country"
                        required={true}
                        InputLabelProps={{shrink: true, classes: {focused: classes.labelFocused}}}
                        SelectProps={{classes: {focused: classes.labelFocused}}}
                      />
                    )}
                  />
                </Box>
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  required={true}
                  labelText="Zipcode"
                  id="zipcode"
                  value={userInfo?.contactInfo?.zipcode}
                  info={userInfo}
                  updateInfo={setUserInfo}
                  nestedKey="contactInfo"
                />
              </GridItem>
            </GridContainer>
            <GridContainer style={{ marginTop: "25px" }}>
              <GridItem xs={12} sm={12} md={4}>
                <InputLabel
                  style={{
                    fontSize: "12px",
                    color: "rgba(0, 0, 0, 0.54)",
                  }}
                >
                  Primary Phone *
                </InputLabel>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <PhoneInput
                    country={"us"}
                    containerStyle={{ zIndex: 4 }}
                    inputStyle={{
                      border: "0px",
                      borderBottom: "1px solid #d2d2d2",
                      borderRadius: "0px",
                    }}
                    buttonStyle={{
                      border: "0px",
                      background: "none",
                    }}
                    enableSearch={true}
                    placeholder="212345678"
                    value={userInfo?.contactInfo?.primaryPhone}
                    onChange={(val) => {
                      setUserInfo({
                        ...userInfo,
                        contactInfo: {
                          ...(userInfo?.contactInfo || {}),
                          primaryPhone: val,
                        },
                      });
                    }}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={12} md={4} mt={2}>
                <InputLabel
                  style={{
                    fontSize: "12px",
                    color: "rgba(0, 0, 0, 0.54)",
                  }}
                >
                  Secondary Phone
                </InputLabel>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <PhoneInput
                    country={"us"}
                    containerStyle={{ zIndex: 4 }}
                    inputStyle={{
                      border: "0px",
                      borderBottom: "1px solid #d2d2d2",
                      borderRadius: "0px",
                    }}
                    buttonStyle={{
                      border: "0px",
                      background: "none",
                    }}
                    enableSearch={true}
                    placeholder="212345678"
                    value={userInfo?.contactInfo?.secondaryPhone}
                    onChange={(val) => {
                      setUserInfo({
                        ...userInfo,
                        contactInfo: {
                          ...(userInfo?.contactInfo || {}),
                          secondaryPhone: val,
                        },
                      });
                    }}
                  />
                </FormControl>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12}>
        <Box textAlign="right">
          <Button onClick={validateForm} color="danger">{id ? "Save" : "Submit"}</Button>
          <Button onClick={() => {history.push(`/admin/company`);}}>Cancel</Button>
        </Box>
      </GridItem>
      <Snackbar
        place="tr"
        color="danger"
        icon={AddAlert}
        message={alertMessage}
        open={toastStatus}
        closeNotification={() => setToastStatus(false)}
        close
      />
      <Loader status={loading} />
    </GridContainer>
  );
}
